import styled from 'vue-styled-components';
import theme from '@/config/theme';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1.5rem;

  & .radioButtonContainer {
    > div {
      display: grid;
      grid-auto-rows: 50px;
      grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
      row-gap: ${theme.spacings.xxxlarge};
    }

    & .error {
      background-color: ${theme.colors.supportErrorAlpha20};
      border-radius: 0.3rem;
      padding: 0.5rem;
      grid-column: 1 / 3;
      color: ${theme.colors.supportError};
      font-weight: 600;
    }
  }

  & .labelNoneEvents {
    pointer-events: none;
  }
`;

export const Description = styled.p``;

export const TextArea = styled.textarea`
  box-sizing: border-box;
  border: 1px solid ${theme.colors.gray3};
  border-radius: 8px;
  height: 100%;
  padding: 0.5rem;
  max-height: 50px;
  resize: vertical;
`;
